<template>
  <div
      class="loginContainer"
      style="">
    <Login-component />
  </div>

</template>

<script>

import LoginComponent from "../../../components/b2b/dlcon/LoginComponent";

export default {
  name: "dlconLogin.vue",
  components: {LoginComponent}
}
</script>

<style scoped>
.loginContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #D2D2D2;
}

</style>
